import BusinessServiceEdit from './BusinessServiceEdit';
import BusinessServiceList from './BusinessServiceList';

export default {
  name: 'business_service',
  list: BusinessServiceList,
  edit: BusinessServiceEdit,
};
